import { RemoveFromBasketDocument } from '@packages/gql/generated/shopping/RemoveFromBasketDocument';
import { RemoveFromWishlistFullDocument } from '@packages/gql/generated/shopping/RemoveFromWishlistFullDocument';

export const GraphqlDocuments = {
  basket: RemoveFromBasketDocument,
  wishlist: RemoveFromWishlistFullDocument,
} as const;
